const FR = new Intl.NumberFormat('fr-FR');
const FR_EUR = new Intl.NumberFormat('fr-FR', {
  style: 'currency',
  currency: 'EUR',
  maximumFractionDigits: 0,
});

export function formatNumber(n: number, decimals = 0): string {
  return new Intl.NumberFormat('fr-FR', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(n);
}

export function formatEur(n: number): string {
  return FR_EUR.format(n);
}

// Quantité éventuellement fractionnaire, sans zéros décimaux superflus
// (ex : 1 → « 1 », 0.5 → « 0,5 », 0.25 → « 0,25 »). Utilisé pour les ETP.
const FR_QUANTITY = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 });
export function formatQuantity(n: number): string {
  return FR_QUANTITY.format(n);
}

// Compact abbreviation (k, M) used in charts/KPI cards (EC7)
export function formatCompact(n: number): string {
  if (Math.abs(n) >= 1_000_000) return `${FR.format(Math.round(n / 100_000) / 10)} M€`;
  if (Math.abs(n) >= 10_000) return `${FR.format(Math.round(n / 1_000))} k€`;
  return formatEur(n);
}
